import { MapPin, Sparkles, Store, Home, Users, Package } from 'lucide-react'

export default function LocalPresenceSection({
  title,
  subtitle,
  cities,
  neighborhoods,
  imageSrc,
  badgeText = "استهداف محلي دقيق",
  showTrustSignals = false,
}) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-background to-muted/40 py-20 md:py-28">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 h-80 w-80 rounded-full bg-primary/5 blur-3xl" />
      </div>
      <div className="container relative z-10 mx-auto px-4">
        <div className="grid gap-12 lg:grid-cols-2 items-center">
          {/* Image side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img src={imageSrc} alt="الوصول المحلي" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-4 left-6 bg-background rounded-full shadow-lg px-4 py-2 flex items-center gap-2 text-sm font-medium">
              <MapPin className="h-4 w-4 text-primary" />
              <span>+ {cities.length + Math.floor(neighborhoods.length / 2)} حياً ومدينة</span>
            </div>
          </div>

          {/* Content side */}
          <div className="order-1 lg:order-2 space-y-6">
            <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1.5 text-sm text-primary font-medium">
              <Sparkles className="h-4 w-4" />
              <span>{badgeText}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight">{title}</h2>
            <p className="text-muted-foreground text-lg leading-relaxed">{subtitle}</p>

            <div className="grid gap-6 sm:grid-cols-2 pt-4">
              <div className="space-y-3">
                <div className="flex items-center gap-2 text-primary font-semibold">
                  <Store className="h-5 w-5" />
                  <span>مدننا</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {cities.map(city => (
                    <span key={city} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-sm shadow-sm transition-all hover:bg-muted hover:shadow-md">
                      <MapPin className="h-3.5 w-3.5 text-primary" />
                      {city}
                    </span>
                  ))}
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-center gap-2 text-primary font-semibold">
                  <Home className="h-5 w-5" />
                  <span>أحياء العيون</span>
                </div>
                <div className="flex flex-wrap gap-2">
                  {neighborhoods.slice(0, 5).map(hood => (
                    <span key={hood} className="inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-sm shadow-sm transition-all hover:bg-muted hover:shadow-md">
                      <Home className="h-3.5 w-3.5 text-primary" />
                      {hood}
                    </span>
                  ))}
                  {neighborhoods.length > 5 && (
                    <span className="inline-flex items-center rounded-full bg-muted/50 px-3 py-1.5 text-sm text-muted-foreground">
                      + {neighborhoods.length - 5} آخر
                    </span>
                  )}
                </div>
              </div>
            </div>

            {showTrustSignals && (
              <div className="flex flex-wrap gap-6 pt-4 border-t border-border/50 mt-2">
                <div className="flex items-center gap-2">
                  <Users className="h-5 w-5 text-primary" />
                  <span className="text-sm font-medium">أكثر من 500 تاجر</span>
                </div>
                <div className="flex items-center gap-2">
                  <Package className="h-5 w-5 text-primary" />
                  <span className="text-sm font-medium">آلاف المنتجات</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}